<template>
  <div>
    <user-list v-if="organization?.id" :organization-id="organization.id" />
  </div>
</template>

<script>
import UserList from "@elements/UserList.vue";

export default {
  components: {UserList},

  computed: {
    organization() {
      return this.$parent.organization ?? null
    },
  },
}
</script>
